import React from "react";
import { Box } from "@mui/material";

/* ======================================================
   Gemeinsame Markenfarben & -elemente der Website
====================================================== */

export const INK = "#2a2353"; // helleres, satteres Lila – passend zu ACCENT/ACCENT_DARK, nicht mehr fast schwarz
export const INK_SOFT = "#342b63";
export const ACCENT = "#8b7fea"; // helles Markenviolett für dunkle Flächen
export const ACCENT_DARK = "#5b4fd4"; // satteres Violett für helle Flächen

// Gürtelfarben (Weiß → Schwarz) als Erkennungszeichen für Kampfsport
export const BELT_COLORS = [
  "#f1f3f5",
  "#ffd43b",
  "#37b24d",
  "#339af0",
  "#f03e3e",
  "#1a1b1e",
];

export const BeltStripe = ({ height = 6 }) => (
  <Box sx={{ display: "flex", height }}>
    {BELT_COLORS.map((c) => (
      <Box key={c} sx={{ flex: 1, bgcolor: c }} />
    ))}
  </Box>
);

/* ======================================================
   Easing/Motion-Tokens (Emil-Kowalski-Animationsphilosophie):
   stärkere Kurven als die CSS-Standards, kurze Dauer, nur
   transform/opacity. Eine Quelle für die ganze Seite.
====================================================== */
export const EASE_OUT = "cubic-bezier(0.23, 1, 0.32, 1)";
export const EASE_IN_OUT = "cubic-bezier(0.77, 0, 0.175, 1)";

// Primäre CTA-Buttons: dezenter Verlauf + Schein statt Fläche, damit
// "kostenlos testen" im Gesamtbild stärker heraussticht.
const CTA_LIGHT = "#8b7fea";
export const CTA_GRADIENT = `linear-gradient(135deg, ${CTA_LIGHT} 0%, ${ACCENT_DARK} 100%)`;
export const ctaGlowSx = {
  background: CTA_GRADIENT,
  boxShadow:
    "inset 0 1px 0 rgba(255,255,255,0.18), 0 8px 22px -10px rgba(91,79,212,0.6)",
  transition: `box-shadow 200ms ${EASE_OUT}, filter 200ms ${EASE_OUT}`,
  "&:hover": {
    background: CTA_GRADIENT,
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,0.22), 0 12px 30px -10px rgba(91,79,212,0.7)",
    filter: "brightness(1.06)",
  },
};
